var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4v7a1.83 1.83 0 01-.41 1L11 20.59 3.41 13 12 4.41A1.83 1.83 0 0113 4h7m0-1h-7a2.78 2.78 0 00-1.71.71l-8.58 8.58a1 1 0 000 1.41l7.59 7.59a1 1 0 001.41 0l8.59-8.59A2.78 2.78 0 0021 11V4a1 1 0 00-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6a1 1 0 11-1 1 1 1 0 011-1m0-1a2 2 0 102 2 2 2 0 00-2-2z"
  })));
}
export default SvgNameTag;